// src/UberFilter/scrollbarSx.ts
var scrollbarSx = {
  "&::-webkit-scrollbar": {
    width: "8px"
  },
  "&::-webkit-scrollbar-track": {
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: "4px"
  },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.3)"
    }
  }
};
var scrollbarSx_default = scrollbarSx;

export {
  scrollbarSx_default
};
